<template>
  <!-- Social -->
  <v-card color="#E0E0E0" class="py-2 mb-5">
    <div class="drawer-right__social d-flex justify-space-around px-8">
      <a
        v-if="course && course.facebookUrl"
        :href="course.facebookUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-facebook-f</v-icon>
      </a>
      <a
        v-if="course && course.twitterUrl"
        :href="course.twitterUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-twitter</v-icon>
      </a>
      <a
        v-if="course && course.linkedinUrl"
        :href="course.linkedinUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-linkedin-in</v-icon>
      </a>
      <a
        v-if="course && course.instagramUrl"
        :href="course.instagramUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-instagram</v-icon>
      </a>
      <a
        v-if="course && course.youtubeUrl"
        :href="course.youtubeUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-youtube</v-icon>
      </a>
      <a
        v-if="course && course.tripadvisorUrl"
        :href="course.tripadvisorUrl"
        target="_blank"
      >
        <v-icon color="black" size="18">fab fa-tripadvisor</v-icon>
      </a>
    </div>
  </v-card>
</template>
<script>

export default {
  name: 'SocialCourseCard',
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
  }
};
</script>